<template>
    <el-dialog
        title="New Campaign"
        :visible.sync="showForm"
        :destroy-on-close="true"
        width="85%"
        append-to-body
    >
        Name:
        <input type="text" class="form-control" v-model="formData.name"></input>

        <template v-if="add_jobs.length">
            <h5 style="margin-top: 30px;">Add Jobs</h5>
            <jobid-job-list :employer_id="employer_id" :job_ids="add_jobs"></jobid-job-list>
        </template>

        <btn icon="fas fa-plus" :click="openAddJobsDialog">Add jobs</btn>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showForm = false">Close</el-button>
            <el-button type="primary" @click="create">Save</el-button>
        </span>

        <jobs-picker
            :show="show_dialogs.add_jobs"
            :employer_id="employer_id"
            :exclude_campaign_id="null"
            @close="show_dialogs.add_jobs = false"
            v-model="add_jobs"
        ></jobs-picker>
    </el-dialog>
</template>

<script>
import JobidJobList from "../../Job/vue/campaigns/jobid-job-list";
import JobsPicker from "../../Job/vue/campaigns/jobs-picker";

export default {
    components: {JobsPicker, JobidJobList},
    props: [
        'show',
        'employer_id'
    ],
    data() {
        return {
            show_dialogs: {
                add_jobs: false
            },
            formData: {
                name: ''
            },
            add_jobs: []
        };
    },
    computed: {
        showForm: {
            get() { return this.show; },
            set(val) { this.$emit('close'); }
        }
    },
    methods: {
        create() {
            axios.post(url(`admin/employer/${this.employer_id}/campaigns/create`), {
                name: this.formData.name,
                employer_id: this.employer_id,
                add_jobs: this.add_jobs
            }).then(response => {
                this.showForm = false;
                this.formData.name = '';
                this.$emit('updated');
            })
        },
        openAddJobsDialog() {
            this.show_dialogs.add_jobs = true;
        },
    }
}
</script>

<style>
</style>